import * as React from "react";
import { forwardRef } from "react";
const SvgInfoOutlined = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M9.242 6.829a1.071 1.071 0 1 1 1.516-1.515 1.071 1.071 0 0 1-1.516 1.515ZM9.286 8.75a.18.18 0 0 1 .178-.179h1.072a.18.18 0 0 1 .178.179v6.071a.18.18 0 0 1-.178.179H9.464a.18.18 0 0 1-.178-.179V8.75Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M0 10C0 4.478 4.478 0 10 0s10 4.478 10 10-4.478 10-10 10S0 15.522 0 10Zm1.696 0A8.305 8.305 0 0 0 10 18.304 8.305 8.305 0 0 0 18.304 10 8.305 8.305 0 0 0 10 1.696 8.305 8.305 0 0 0 1.696 10Z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgInfoOutlined);
export default ForwardRef;
